import DetailPageLayout from "../Layout/DetailPageLayout";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { useReloadWarning } from "../../common/hooks";
import { TextM, TextS } from "../../common/text";
import {
  ContentContainer,
  FindAccountHeader,
  FindAccountWrapper,
  FindPhoneNum,
  NextBtn,
  NextBtnText,
} from "./FindAccountPhoneNum.styles";
import { findAccountAtom } from "../../recoil/atoms";

const FindAccountPhoneNum = () => {
  const navigate = useNavigate();
  const setFindAccountAtom = useSetRecoilState(findAccountAtom);
  const [phoneNum, setPhoneNum] = useState("");
  const [phoneNumMessage, setPhoneNumMessage] = useState("");
  const [isValidPhoneNum, setIsValidPhoneNum] = useState(false);

  const phoneNumRegex = /^(\d{3})-(\d{4})-(\d{4})$/;

  const onCheckPhoneNum = (e) => {
    const currentPhoneNum = e.target.value
      .replace(/[^0-9]/g, "")
      .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
    setPhoneNum(currentPhoneNum);

    if (!phoneNumRegex.test(currentPhoneNum)) {
      setIsValidPhoneNum(false);
      setPhoneNumMessage("전화번호를 확인해주세요");
    } else {
      setIsValidPhoneNum(true);
      setPhoneNumMessage("다음버튼을 눌러주세요");
      setFindAccountAtom((prev) => ({
        ...prev,
        phone: currentPhoneNum.replaceAll("-", ""),
      }));
    }
  };

  const goNext = () => {
    console.log("hello");
    if (isValidPhoneNum) navigate("/find-account/validate");
  };
  return (
    <DetailPageLayout headerText={"휴대폰 인증"}>
      <ContentContainer>
        <FindAccountHeader>
          <TextM>휴대폰 본인 인증이 필요합니다.</TextM>
          <TextM>휴대전화번호를 입력해주세요</TextM>
        </FindAccountHeader>
        <FindAccountWrapper>
          <FindPhoneNum
            onChange={onCheckPhoneNum}
            value={phoneNum}
            placeholder={"숫자만 입력해주세요."}
            variant="standard"
            helperText={
              phoneNum && <TextS color={"#f44b59"}>{phoneNumMessage}</TextS>
            }
          ></FindPhoneNum>
        </FindAccountWrapper>

        <NextBtn onClick={goNext} isValidPhoneNum={isValidPhoneNum}>
          <NextBtnText isValidPhoneNum={isValidPhoneNum}>다음</NextBtnText>
        </NextBtn>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default FindAccountPhoneNum;
